<template>
  <div class="pb-2">
    <b-row class="px-2 align-items-center section-header-row no-gutters">
      <b-col><h3>Credential</h3></b-col>
      <b-col cols="2" class="text-right">
        <b-button
        v-b-modal.credentialEdit
        class="main-navigation-button edit_button"
        variant="white"
        btn-color="primary1"
      >
        <v-avatar size="25">
          <img src="img/Edit.png" />
        </v-avatar>
      </b-button>
      </b-col>
    </b-row>
      <b-modal
        id="credentialEdit"
        title="Credential"
        size="md"
        centered
        hide-footer
        header-class="header-nipige-class"
      >
        <sauthmodel>
          <template v-slot:footer-button="data">
            <b-row class="mt-3">
              <b-col md="4"> </b-col>
              <b-col md="4">
                <b-button
                  class="btn btn-block"
                  btn-color="primary"
                  @click="AuthToNext(data.data)"
                  >Update</b-button
                >
              </b-col>
              <b-col md="4"></b-col>
            </b-row>
          </template>
        </sauthmodel>
      </b-modal>
    <b-row class="px-2 mt-1">
      <b-col>
        <b-row>
          <b-col md="6">
            <p class="left-text">User Name :</p>
          </b-col>
          <b-col md="6">
            <p class="right-text">
              {{ authData && authData.userName }}
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="line"> </b-col>
    </b-row>
    <b-row class="m-2 line-bottom"></b-row>
    <b-row class="px-2">
      <b-col>
        <b-row>
          <b-col md="6">
            <p class="left-text">Phone # :</p>
          </b-col>
          <b-col md="6">
            <p class="right-text">
              {{ authData && authData.phone }}
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col class="line" md="5">
            <p class="left-text">Email Id :</p>
          </b-col>
          <b-col md="7">
            <p class="right-text">
              {{ authData && authData.email }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="m-2 line-bottom"></b-row>
  </div>
</template>

<script>
import sauthmodel from "@/components/Partner/PartnerEdit/AuthenticationStepper";
import { mapGetters } from "vuex";
export default {
  props: ["authData"],
  components: {
    sauthmodel,
  },
  computed: {
    ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
  },
  methods: {
    AuthToNext(data) {
      if (data.securityQuestions.question.value) {
        data.securityQuestions = {
          answer: data.securityQuestions.answer,
          question: data.securityQuestions.question.value,
        };
      } else {
        data.securityQuestions = {
          answer: data.securityQuestions.answer,
          question: data.securityQuestions.question,
        };
      }
      let authenticationData = {
        phone: data.phone,
        email: data.email,
        userName: data.userName,
        securityQuestions: data.securityQuestions,
      };
      let payload = {
        id: this.partnerAllData._id,
        data: {
          authentication: authenticationData,
        },
      };
      this.$store
        .dispatch("partner/updatePartner", payload)
        .then((result) => {
          this.$swal({
            title: "Success",
            text: "Partner Edited successfully!",
            type: "success",
          });
          this.$emit("reload-partner", this.partnerAllData._id);
          this.$root.$emit("bv::hide::modal", "credentialEdit", "#btnShow");
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: "Could not Edited partner",
            type: "error",
          });
        });
    },
  },
};
</script>
<style>
.text-style {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: rgba(143, 143, 143, 0.87);
}
.left-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  color: #58585b;
}
.right-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}
[btn-color="primary1"] {
  outline: none !important;
  border-radius: 50%;
  height: 39px;
  width: 39px;
  padding: 0;
}
[btn-special="primary1"] {
  border-radius: 50%;
}
.header-nipige-class {
  background-color: var(--secondary);
  border-radius: 10px 10px 0px 0px;
}
.modal-title {
  font-size: 20px;
  color: white;
  text-align: center;
  margin-left: 40%;
}
.modal-content {
  border-radius: 10px 10px 10px 10px;
}
.header-style {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
}
@media (max-width: 767px) {
  .my-content {
    display: none;
  }
}
@media (min-width: 767px) {
  .mobile-responsive {
    display: none;
  }
}
@media (max-width: 767px) {
  .edit_button {
    margin-top: -34px;
  }
}
.line {
  border-left: 1px dashed #c2c2c2;
}
.line-bottom {
  border-bottom: 1px dashed #c2c2c2;
}
@media (max-width: 576px) {
  .edit_button {
    margin-left: auto;
    display: block;
  }

  .b-col {
    display: flex;
    align-items: center;
  }
}
</style>
